@if (showToolbar) {
  <div class="d-flex gap-3 align-items-center">
    <app-tiptap-toolbar
      [editor]="editor"
      [disabled]="ngControl.disabled"
      (undo)="undo.emit()"
      (redo)="redo.emit()"></app-tiptap-toolbar>
    <ng-content select="[appTiptapEditorToolbarAppendix]"></ng-content>
  </div>
}
<tiptap-editor
  class="p-3 border bg-light-subtle rounded-4 min-h-200 d-flex flex-column"
  [editor]="editor"
  [formControl]="ngControl.control"
  [class.disabled]="ngControl.disabled"></tiptap-editor>
<tiptap-bubble-menu
  [editor]="editor"
  [tippyOptions]="bubbleMenuTippyOptions"
  class="btn-group btn-group-sm gap-2 bg-secondary border border-2 border-secondary rounded shadow-lg">
  <ng-content select="[appTiptapEditorBubbleMenuItem]"></ng-content>
</tiptap-bubble-menu>
